import OutsideClickHandler from 'react-outside-click-handler';
import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import styles from './Select.module.css';
import arrow from '../../../assets/images/selectArrow.png';

type SelectProps = {
  id: string
  options: {
    value: string
  }[],
  label?: string
  required?: boolean
  error?: boolean
  value?: string
  width?: string
  isLongLabel?: boolean
  onUpdate: (value: any) => void
}

function Select(props: SelectProps) {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const [value, setValue] = useState<string>('');

  useEffect(() => {
    if (props.value) {
      setValue(props.value);
    }
  }, [props.value]);

  const outsideClickHandler = () => {
    if (isOpen) {
      setIsOpen(false);
    }
  };

  const toggle = () => {
    setIsOpen(prevState => !prevState);
  };

  const optionClickHandler = (optionValue: string) => {
    setValue(optionValue);
    props.onUpdate(optionValue);
    toggle();
  };

  return (
    <div
      className={styles.container}
      style={{ width: props.width }}
    >
      {props.label &&
        <label htmlFor={props.id} className={classNames(
          styles.label, props.isLongLabel && styles.longLabel, { [styles.required]: props.error },
        )}>
          <span>{props.label}</span>
          {props.required && <span className={styles.required}>*</span>}
        </label>
      }
      <OutsideClickHandler onOutsideClick={outsideClickHandler}>
        <div className={classNames(styles.selectInput, { [styles.error]: props.error })}>
          <div
            role='button'
            onClick={toggle}
            className={styles.selectedValue}
            tabIndex={0}
            onKeyDown={toggle}
          >
              <span className={value ? styles.value : styles.placeholder}>
                {value || t('common.placeholder.select')}
              </span>
            <div>
              <img src={arrow} alt='select arrow'
                   className={isOpen ? styles.arrowUp : styles.arrowDown} />
            </div>
          </div>
          {isOpen && (
            <ul>
              {props.options.map(option =>
                <div
                  role='button'
                  key={option.value}
                  onClick={() => optionClickHandler(option.value)}
                  tabIndex={0}
                  onKeyDown={() => optionClickHandler(option.value)}
                >
                  <li>
                    {option.value}
                  </li>
                </div>,
              )}
            </ul>
          )}
        </div>
      </OutsideClickHandler>
    </div>
  );
}

export default Select;
